import { PackageCategory } from '~entities/package-category/model/package-category.types';
import { Package } from '~entities/package/model/package.types';
import { HomeIcon } from 'lucide-react';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
    getBreadcrumbs: () => [
      {
        icon: HomeIcon,
        href: '/',
      },
    ],
  },
  booking: {
    path: '/booking/',
    getHref: () => '/booking/',
  },

  compare: {
    path: '/compare/',
    getHref: () => '/compare/',
  },

  packages: {
    path: '/packages/',
    getHref: (categoryId?: number) =>
      `/packages/${categoryId ? `#${categoryId}` : ''}`,
    getBreadcrumbs: () => [
      ...paths.home.getBreadcrumbs(),
      {
        name: 'booking.package_other',
        href: '/packages/',
      },
    ],
    details: {
      path: '/package/:id/',
      getHref: (id: number) => `/package/${id}/`,
      getBreadcrumbs: (
        packageItem: Package,
        packageCategory?: PackageCategory,
      ) =>
        [
          ...paths.packages.getBreadcrumbs(),
          packageCategory && {
            name: packageCategory?.name,
            href: `/packages/#${packageCategory?.id.toString()}`,
          },
          {
            name: packageItem.name,
            href: `/package/${packageItem.id}/`,
          },
        ].filter(item => !!item),
    },
  },
  lastMinutePackages: {
    path: '/last-minute/',
    getHref: () => '/last-minute/',
    getBreadcrumbs: () => [
      ...paths.home.getBreadcrumbs(),
      {
        name: 'booking.lastMinutePackage_other',
        href: '/last-minute/',
      },
    ],
    details: {
      path: '/last-minute/:id/',
      getHref: (id: number) => `/last-minute/${id}/`,
      getBreadcrumbs: (packageItem: Package) => [
        ...paths.lastMinutePackages.getBreadcrumbs(),
        {
          name: packageItem.name,
          href: `/last-minute/${packageItem.id}/`,
        },
      ],
    },
  },

  bookingSuccess: {
    path: '/success/',
    getHref: () => '/success/',
  },

  bookingError: {
    path: '/error/',
    getHref: () => '/error/',
  },

  inquirySuccess: {
    path: '/inquire-success/',
    getHref: () => '/inquire-success/',
  },

  inquiryError: {
    path: '/inquire-error/',
    getHref: () => '/inquire-error/',
  },

  addVariant: {
    path: `/add-variant/:variantId/`,
    getHref: (id: string) => `/add-variant/${id}/`,
  },

  addRoom: {
    path: '/add-room/',
    getHref: () => '/add-room/',
  },

  search: {
    path: '/search/',
    getHref: () => '/search/',
  },
} as const;
